import { makeStyles } from "@material-ui/core";

export const useFieldStyles = makeStyles({
  multilineInput: {
    "& textarea": {
      // non-scrolling gap so scrolled text clears the floating label
      marginTop: 8,
      paddingTop: "2px !important",
    },
  },
  fieldLabel: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "calc(100% - 24px)",
    "&.MuiInputLabel-shrink": {
      width: "max-content", // lifts the absolute-positioning width cap
      maxWidth: "calc(133% - 32px)",
      pointerEvents: "auto", // enables the title tooltip
    },
  },
});
